export default {
  methods: {
    render_right(data,width) {
      let leftChart = [];
      leftChart = data.map(v=>{
        return {
          value: v.saleNum,
          name: v.categoryName
        }
      })
      let option = {
        title: {
          text: '搭配分类占比',
          x: 'center',
          y: width == 1920 ? '10%' : '5%',
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            crossStyle: {
                color: '#999'
            }
        },
        grid:{
          left: 0,
          top : 0,
          left: 0,
          bottom: 0,
          containLabel:true
      },
        // formatter: params => {
        //   // console.log(params);
        //   const index = params.componentIndex;
        //   let nameLeft = ''
        //   if(index == 0) {
        //     nameLeft = '销量段'
        //   }else {
        //     nameLeft = ''
        //   }
        //   let indexOf = ['saleNumProportion','categoryProportion']
        //   let name = indexOf[index]
        //   let str = "";
        //   // console.log(data[name]);
        //   let arr = data[name][params.dataIndex]
        //   str = `${params.marker}${arr.category}${nameLeft}<br/>产品数<span style="inline-block; width:50px; text-algin:right; float:right; font-weight:800; margin-left: 20px;">${arr.productCount||0}</span><br/>占比<span style="inline-block; width:50px; font-weight:800; text-algin:right; float:right; margin-left: 20px;">${arr.proportion + '%'||0}</span><br/>`
        //   return str
        // },
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['70%', '50%'],
            center: width == 1920 ? ['50%', '50%'] : ['50%', '55%'] ,
            minAngle: 5,  //设置扇形的最小占比
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: leftChart
          },
        ]
      };
      let $instance = this.$echarts.init(this.$refs['distribute']);
      $instance.setOption(option,true);
    }
  }
}